import React from 'react';
import { Link } from 'react-router-dom';
import { BookModel } from '../../../interfaces/book.interface';

interface BookCardProps {
  book: BookModel;
  imageUrl: string;
  rotation: { rotateX: number; rotateY: number };
  handleMouseMove: (id: string, e: React.MouseEvent) => void;
  handleMouseLeave: (id: string) => void;
}

const BookCardItem: React.FC<BookCardProps> = ({ book, imageUrl, rotation, handleMouseMove, handleMouseLeave }) => {
  return (
    <div
      key={book.id}
      className="flex flex-col items-center book-item font-sans text-white uppercase text-2xl font-bold w-full rounded-md mx-auto mb-2"
    >
      <a href={`/books/${book.id}`}>
        <div
          className="relative !h-64 !w-64 book-cover shadow-xl"
          style={{
            backgroundImage: `url('${imageUrl}')`,
            backgroundSize: 'cover',
            transform: `rotateX(${rotation.rotateX}deg) rotateY(${rotation.rotateY}deg)`,
            transition: 'transform 0.1s ease-out'
          }}
          onMouseMove={(e) => handleMouseMove(book.id!, e)}
          onMouseLeave={() => handleMouseLeave(book.id!)}
        >
          <div
            className="absolute top-0 left-0 h-full w-full"
            style={{ backgroundImage: `url('/book.png')`, backgroundSize: 'cover' }}
          ></div>
          <div className="book-spine"></div>
          <div
            className="relative top-48 text-storytan text-sm bg-black bg-opacity-70 leading-none font-bold font-serif block p-4"
          >
            {book.title}
          </div>
        </div>
      </a>
      {book.pdfUrl && (
        <a
          href={book.pdfUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="text-sm text-storyblue underline h-24"
        >
          View PDF
        </a>
      )}
      <div className="flex flex-col gap-1 mt-1">
        <div className="flex w-full justify-around">
          <Link
            to="#"
            className="w-[49%] bg-storygreen text-white font-bold font-sans rounded-md p-2 text-xs capitalize"
          >
            Edit
          </Link>
          <Link
            to={`/books/${book.id}`}
            className="w-[49%] bg-storygreen text-white font-bold font-sans rounded-md p-2 text-xs capitalize"
          >
            View
          </Link>
        </div>
        <Link
          to="#"
          className="w-[100%] bg-storygreen text-white font-bold font-sans rounded-md p-2 text-xs capitalize"
        >
          Purchase Physical Book
        </Link>
      </div>
    </div>
  );
};

export default BookCardItem;
